var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import MulShopOamount from './MulShopOamount.vue';
import { summaries } from '../../helper/util';
import PurInService from "../../api/PurInService";
import GoodImageView from "./components/GoodViewer.vue";
import { Loading } from 'element-ui';
var GoodTable = (function (_super) {
    __extends(GoodTable, _super);
    function GoodTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.tableHeight = 300;
        _this.mulShopList = [];
        return _this;
    }
    GoodTable.prototype.created = function () {
        this.service = PurInService.getInstance();
    };
    GoodTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 300;
        }, 300);
    };
    GoodTable.prototype.showShopDetail = function (row) {
        this.mulShopList = row.shop_info || [];
        this.$refs.mulShop.showRelease();
    };
    GoodTable.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = [
            'order_warehousing_amount',
            'order_gift_amount',
            'order_detail_amount',
            'order_detail_oamount',
            'order_detail_inamount',
            'order_diff',
            'total_price',
            'order_detail_after_money',
            'order_detail_tax_money',
        ];
        sums = summaries(param, showSum);
        sums[0] = '单据合计';
        return sums;
    };
    GoodTable.prototype.LookImage = function (orderDetailIds) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.orderDetailImg({ order_detail_ids: orderDetailIds }).then(function (res) {
            _this.imageArr = Array.isArray(res.data.data) ? res.data.data : [];
            loadingInstance.close();
            _this.imageOpen = true;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    GoodTable.prototype.closeimg = function (type) {
        this.imageOpen = type;
    };
    __decorate([
        Prop({
            type: Array,
            default: [],
        })
    ], GoodTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: Object,
            default: {},
        })
    ], GoodTable.prototype, "billData", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'default',
        })
    ], GoodTable.prototype, "type", void 0);
    GoodTable = __decorate([
        Component({
            components: {
                'mul-shop-oamount': MulShopOamount,
                'good-image-view': GoodImageView
            },
            computed: {
                isHideGiftAmount: function () {
                    var billData = this.billData || {};
                    return (billData.logistics_type === 2 && billData.depot_in_model === 1) || [4, 5].includes(billData.logistics_type);
                },
            }
        })
    ], GoodTable);
    return GoodTable;
}(Vue));
export default GoodTable;
